<template>
	<div class="calculateBox">
		<div class="banner">
			<div class="txt">算力板块</div>
		</div>
		<div class="infoBox">
			<div class="name">中明智算中心</div>
			<div class="flexBox desBox">
				<img src="../../../assets/img/calculate/demo_0.jpg" class="icon coverImg">
				<div class="des">
					中明智算中心位于张家口市经开区数字服务产业基地，预计总投资约200亿元，首期算力将于2025年2季度前上线，作为国家一体化网络京津冀枢纽张家口算力示范项目，预计投产后将提供国际先进算力，面向平台类互联网、基础大模型、科研院所及高校、工业数字化、能源和制造业，提供高效普惠算力服务。以异构多元系统架构，支撑万亿参数量级，生成式人工智能的训练、推理、精调等任务计算服务。
				</div>
			</div>
			<div class="introBox flexBox">
				<ul class="tagBox">
					<li class="flexBox" v-for="item in tagList">
						<div class="tag">{{item.name}}</div>
						<div class="val">{{item.label}}</div>
					</li>
				</ul>
				<img src="../../../assets/img/calculate/demo_1.png" class="icon">
			</div>
			<div class="tip">京津冀地区单体规模最大的公共服务算力集群之一 </div>
			<ul class="list flexBox">
				<li class="flexBox" v-for="item in infoList">
					<div class="txt flexBox">
						<div class="val">{{item.name}}</div>
					</div>
					<i class="line"></i>
				</li>
			</ul>
		</div>
		<div class="baseBox">
			<div class="name">中明人工智能算电基地</div>
			<div class="tip">ZHONGMING AI COMPUTING AND POWER BASE</div>
			<ul class="list flexBox">
				<li class="item" v-for="item in baseList">
					<img :src="item.icon" class="icon">
					<div class="txt" v-html="item.name" style="white-space: pre-wrap;"></div>
				</li>
			</ul>

			<ul class="tableList row">
				<li class="flexBox" v-for="item in baseTabel">
					<div class="txt">{{item.name}}</div>
					<div class="des" v-html="item.des" style="white-space: pre-wrap;"></div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Calculate',
		components: {

		},
		data() {
			return {
				tagList: [{
					name: "算力规模",
					label: "超5万p（FP16）"
				}, {
					name: "项目总功率",
					label: "65兆瓦（IT ）首期交付22MW续建约43MW"
				}, {
					name: "机柜功率",
					label: "风冷23-32千瓦 / 液冷40-120千瓦 "
				}, {
					name: "单模块功率",
					label: "1.6-2.4MW 至北京网络双向时延<2ms 多路由大容量 "
				}],
				infoList: [{
					name: '国内首批万卡万P算力集群组件AI技术团队，打造AI孵化能力'
				}, {
					name: '“绿电直联，就地消纳，余电上网”的方式实现电力保障，成功纳入国家数据局算电协同先行先试项目。'
				}, {
					name: '距北京一小时可达的首个超大规模智算中心，网络时延小于2ms，可充分满足训推一体化算力需求。'
				}, {
					name: '以高端算力为主的异构多元架构，可满足万亿及参数的大模型训练使用，项目预留地块，可根据市场需求灵活扩展算力规模。'
				}],
				baseList: [{
					icon: require("../../../assets/img/calculate/icon_0.png"),
					name: '由风光水火气储超大规模<br>可再生能源项目为支撑'
				}, {
					icon: require("../../../assets/img/calculate/icon_1.png"),
					name: '服务大规模算力集群及<br>相关产业布局撑'
				}, {
					icon: require("../../../assets/img/calculate/icon_2.png"),
					name: '采用 “清洁能源协调 + <br>大型智算” 模式'
				}, {
					icon: require("../../../assets/img/calculate/icon_3.png"),
					name: '探索实践算力和绿色电力 <br>“双力一体化” 产业路径'
				}],
				baseTabel: [{
					name: "数字产业园",
					des: "一期：规划用地2000 亩<br>满足IT功率水平 2GW 的算力园区电力负荷需求<br>远期可扩展至 6000 亩，满足IT功率水平6-8GW 的算力园区电力负荷需求。"
				}, {
					name: "可再生能源",
					des: "一期：5GW 装机规模的风光发电项目<br>绿色、经济、规模、稳定。"
				}, {
					name: "地理位置优越",
					des: "位于东数西算张家口集群、京津冀核心<br>经济区、超大型数据基地集群"
				}, {
					name: "土地资源充足",
					des: "整体规划设计、降低扩容成本、支持长<br>期战略"
				}, {
					name: "电力保障可靠",
					des: "可提供绿色、经济、规模、稳定的电力<br>保障"
				}, {
					name: "网络优势",
					des: "北京网络时延小于 2ms"
				}, {
					name: "灵活合作模式",
					des: "规划合理、形态灵活、兼容性强、可灵<br>活交付"
				}, {
					name: "快速交付",
					des: "建设管理体系完善，能够实现 9-12 个<br>月内IT交付"
				}, {
					name: "可持续扩容",
					des: "集群规模效应、灵活调配资源、支持业<br>务拓展"
				}, {
					name: "服务支持能力强",
					des: "绿电消纳服务支持、交易核证服务支持"
				}]
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/calculate.css");
</style>